import { addToChainAfter, addToChainBefore, ApiHandler } from "@insite/client-framework/HandlerCreator";
import { GetAccountShipToCollectionApiParameter } from "@insite/client-framework/Services/AccountService";
import {
    chain,
    DispatchCompleteLoadAccountShipToCollection,
} from "@insite/client-framework/Store/Data/AccountShipTos/Handlers/LoadAccountShipToCollection";
import { AccountShipToCollectionModel } from "@insite/client-framework/Types/ApiModels";
import CustomApplicationState from "@WhiteCap/Store/Data/CustomApplicationState/CustomApplicationState";

type HandlerType = ApiHandler<GetAccountShipToCollectionApiParameter, AccountShipToCollectionModel>;

export const DispatchCompleteLoadAccountShipToCollectionUpdated: HandlerType = props => {
    (props as unknown as any).dispatch({
        type: "Custom/AccountShipTos/CompleteSearchAccountShipToCollectionUpdated",
        collection: props.apiResult,
        parameter: props.parameter,
    });
};

export const DispatchInfiniteScrollCollectionUpdated: HandlerType = props => {
    const previousState = props.getState() as CustomApplicationState;
    const keys = Object.keys(previousState?.WhiteCap.accountShipToReducer.dataViews);
    let value = [] as any;
    let property = {};
    if (keys.length === 1) {
        value = previousState?.WhiteCap.accountShipToReducer.dataViews[keys[keys.length - 1]]?.value;
        property = previousState?.WhiteCap.accountShipToReducer.dataViews[keys[keys.length - 1]]?.properties;
    } else {
        value = previousState?.WhiteCap.accountShipToReducer.dataViews[keys[keys.length - 2]]?.value;
        property = previousState?.WhiteCap.accountShipToReducer.dataViews[keys[keys.length - 2]]?.properties;
    }
    let result = [] as any;
    if (value && props.apiResult.userShipToCollection) {
        if (props.apiResult.pagination?.page === 1) {
            result = props.apiResult.userShipToCollection;
        } else {
            result = [...value, ...props.apiResult.userShipToCollection];
        }

        const prop = props.apiResult.properties;
        const propsResult = { ...property, ...prop };
        props.apiResult.properties = propsResult;
        props.apiResult.userShipToCollection = result;
    }
    (props as unknown as any).dispatch({
        type: "Custom/AccountShipTos/CompleteSearchAccountShipToCollectionUpdated",
        collection: props.apiResult,
        parameter: props.parameter,
    });
};

addToChainBefore(
    chain,
    DispatchCompleteLoadAccountShipToCollection,
    DispatchCompleteLoadAccountShipToCollectionUpdated,
);
addToChainAfter(chain, DispatchCompleteLoadAccountShipToCollection, DispatchInfiniteScrollCollectionUpdated);
